import { Component } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { keys } from 'lodash-es';

import { SlideInOutAnimation } from './animations/animations';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe],
  selector: 'diktup-monorepo-root',
  animations: [SlideInOutAnimation],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public lng: string;
  public cookies = false;
  public customCookies = false;
  public cookiesOptions = {
    essential: true,
    website: true,
    analytics: true,
    marketing: true,
  };

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang(localStorage.getItem('lng'));
    if (localStorage.getItem('lng')) {
      this.lng = localStorage.getItem('lng');
    } else {
      this.changeLng('en');
    }
    if (!this.getCookie('cookieControlPrefs')) {
      this.cookies = true;
    }
  }

  changeLng(lng) {
    this.lng = lng;
    localStorage.setItem('lng', lng);
    this.translate.setDefaultLang(lng);
  }

  handleCustomCookies() {
    this.customCookies = true;
  }

  selectCookie(option) {
    this.cookiesOptions[option] = !this.cookiesOptions[option];
  }

  setCookie(days) {
    const cookieControlPrefs = keys(this.cookiesOptions).filter((c) => this.cookiesOptions[c]);
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = 'cookieControlPrefs' + '=' + cookieControlPrefs + expires + '; path=/';
    this.cookies = false;
  }

  getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}
